const withState = require("../../../../../utils/withState");
const {apiGetMerchantBalance} = require("../../../../../api/merchant/balance");
const formatNum = require("mn-utils/formatNum");
const WrapperWithLoading = require("../../../../dumb/WrapperWithLoading/B");
const Select = require("../../../../dumb/Select/H");
const {LINK_WITHDRAW} = require('../../../../../constants/links');
const Ripple = require('../../../../dumb/Ripple');
const {
  Link,
} = require('../../../../../router');

const React = require("react");
const formatNumFiat = require("../../../../../utils/formatNumFiat");

module.exports = withState((setState, self, onMount) => {
  const currencyCode = 'USDC';

  function handleChangeAssetCode(assetCode) {
    setState({assetCode});
  }

  self.state = {
    loading: true,
  };

  onMount(() => {
    apiGetMerchantBalance().then((res) => {
      const {
        balances = [],
        rolling_reserves: reserves = []
      } = (res.balance_merchant || {});

      const assetsList = balances.map((el, i) => ({id: String(i), code: el.asset_code}));
      const rollingReserve = reserves.find((el) => el.asset_code === 'EUR');

      setState({balances, assetsList, rollingReserve, loading: false});
    });
  });

  const formAmountString = (amount) => `${self.state.loading ? '120 000' : formatNum(amount)} ${currencyCode}`;

  return (state) => {
    const {
      balances = [],
      assetsList = [],
      rollingReserve = {},
      assetCode: selectedAssetId,
      loading,
    } = state;

    const defaultAssetsList = [{id: '0', code: 'USDC'}];
    const disabledBalance = !assetsList.length;
    const assets = disabledBalance ? defaultAssetsList : assetsList;
    const assetId = selectedAssetId || assets[0].id || '0';

    const {
      available: amountAvailable,
      reserved: amountTotal,
      asset_code: assetCode
    } = (balances[assetId] || {});

    return (
      <WrapperWithLoading
        loading={loading}
      >
        <div className="cfx mh-60 mh20@m (w1/2|w@m|ph60|ph0@m|lt)>1">
          <div>
            <div className="mh-25 mh-20@m h94 layoutRow fvaC fhaB ph25 ph20@m bs b1 bcF0 bcbD">
              <div className="pr10 fx1 wmin0">
                <div className="f12 fw4 lts0em wsNW tov ov w">
                  My Actual Balance
                </div>
                <div className="mt9 f23 fw7 lts0em wsNW tov ov w" data-testid="withdrawBalance">
                  {
                    disabledBalance
                      ? '-'
                      : `${formatNumFiat(amountTotal)} ${assetCode}`
                  }
                </div>
              </div>
              <div>
                <Select
                  propValue="id"
                  propName="code"
                  items={assets}
                  value={assetId}
                  onChange={handleChangeAssetCode}
                  disabled={disabledBalance || assets.length === 1}
                  data-testid="withdrawCurrency"
                  displayEmpty
                />
              </div>
            </div>
          </div>
          <div className="mt36@m">
            <div className="mh-25 mh-20@m h94 layoutRow fxdColumn jcC bgF6F6F6 ph25 ph20@m r9">
              <div className="layoutRow fvaC fhaB">
                <div className="pr10 fx1 wmin0">
                  <div className="f12 fw4 lts0em wsNW tov ov wmax">
                    Available Balance
                  </div>
                  <div className="mt9 f23 fw7 lts0em wsNW tov ov wmax" data-testid="withdrawAvailable">
                    {
                      disabledBalance
                        ? '-'
                        : `${formatNumFiat(amountAvailable)} ${assetCode}`
                    }
                  </div>
                </div>
                <div>
                  <Ripple
                    component={Link}
                    className="layoutRow fvaC fhaC f16 fw4 lts0em cF w120 h45 ttU usN
                      bgC.disabled r9 ov bg5B47FF bg4B37EF:not[.disabled]:h dn"
                    href={`${LINK_WITHDRAW}/${assetId}`}
                    disabled={!amountAvailable || Number(amountAvailable) <= 0}
                    data-testid="withdrawLink"
                  >Withdraw</Ripple>
                </div>
              </div>
            </div>
          </div>
          <div className="mt12 mt36@m">
            <div className="mh-25 mh-20@m h94 layoutRow fvaC fhaB ph25 ph20@m bs b1 bcF0 bcbD">
              <div className="pr10 fx1 wmin0">
                <div className="f12 fw4 lts0em wsNW tov ov w">
                  Rolling Reserve
                </div>
                <div className="mt9 f23 fw7 lts0em wsNW tov ov w" data-testid="withdrawBalance">
                  {
                    disabledBalance
                      ? '-'
                      : `${formatNumFiat(rollingReserve.reserved)} ${rollingReserve.asset_code}`
                  }
                </div>
              </div>
            </div>
          </div>
          <div className="mt12 mt36@m">
            <div className="mh-25 mh-20@m h94 layoutRow fxdColumn jcC bgF6F6F6 ph25 ph20@m r9">
              <div className="layoutRow fvaC fhaB">
                <div className="pr10 fx1 wmin0">
                  <div className="f12 fw4 lts0em wsNW tov ov wmax">
                    Available Reserve
                  </div>
                  <div className="mt9 f23 fw7 lts0em wsNW tov ov wmax" data-testid="withdrawAvailable">
                    {
                      !!rollingReserve.available
                        ? `${formatNumFiat(rollingReserve.available)} ${rollingReserve.asset_code}`
                        : '-'
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="h1">
            <div className="mh-25 ph25" />
          </div>
          {/*<div>*/}
          {/*  <div className="mt9 mh-25 ph25 cA3A7AC f12 fw4 lts0em">*/}
          {/*    *Minimum withdrawal limit is {WITHDRAW_MIN_AMOUNT} EUR or similar in the local currency*/}
          {/*  </div>*/}
          {/*</div>*/}
        </div>
      </WrapperWithLoading>
    );
  };
});
